import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from '../menu'; // Import MenuView component
import ToolView from '../toolbar'; // Import ToolView component

/**
 * ComissionsView class extends JetView to create a view for commissions.
 */
export default class ComissionsView extends JetView {
    /**
     * Configures the layout of the ComissionsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Get localization service
        return {
            type: 'wide', // Set layout type to wide
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Set inner layout type to wide
                    rows: [
                        {
                            view: 'tabbar', // Create a tabbar view
                            localId: 'tabbar', // Local ID for tabbar
                            height: 43, // Set height of the tabbar
                            options: [
                                // Define tab options
                                {
                                    id: 'agent.comissions.comissions', // ID for commissions tab
                                    value: _('Comisiones'), // Localized value for commissions
                                },
                                {
                                    id: 'agent.comissions.comissionsReportBetShop', // ID for commissions report tab
                                    value: _('Reporte de Comisiones'), // Localized value for commissions report
                                },
                                {
                                    id: 'agent.comissions.comissionsReportBetShopDetail', // ID for detailed commissions report tab
                                    value: _('Reporte de Comisiones Detallado'), // Localized value for detailed commissions report
                                },
                                {
                                    id: 'agent.comissions.withdrawalRequests', // ID for withdrawal requests tab
                                    value: _('Reporte de Retiros'), // Localized value for withdrawal requests
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the ComissionsView.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with tabbar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
